import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-desktop-step-three',
  templateUrl: './desktop-step-three.component.html',
  styleUrls: ['./desktop-step-three.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopStepThreeComponent {}
